import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import GridColumns from '@components/GridColumns'
import SchoolGroupCard from '@components/SchoolGroupCard'
import SchoolClassCard from '@components/SchoolClassCard'
import { SCHOOL_RESOURCE_TYPES } from '@helpers/constants'
import DemoSchoolClassCard from '@components/DemoSchoolClassCard'
import DemoSchoolGroupCard from '@components/DemoSchoolGroupCard'
import withTooltip from '@components/WithTooltip'
import { useCurrentUser } from '@hooks/useCurrentUser'

const DemoSchoolGroupCardWithTooltip = withTooltip(DemoSchoolGroupCard)
const DemoSchoolClassCardWithTooltip = withTooltip(DemoSchoolClassCard)
const SchoolClassCardWithTooltip = withTooltip(SchoolClassCard)

const SchoolResourceList = (props) => {
  const { items, demoItems, gridCols = 3, resourceType } = props
  const { currentUser } = useCurrentUser()

  return (
    <GridColumns cols={gridCols}>
      {demoItems?.map((item, index) => (
        <Fragment key={item.id}>
          { resourceType === SCHOOL_RESOURCE_TYPES.GROUP &&
            <DemoSchoolGroupCardWithTooltip schoolGroup={item} tooltip={'Dela in elever i nivågrupper.'} />
          }
          { resourceType === SCHOOL_RESOURCE_TYPES.CLASS &&
            <DemoSchoolClassCardWithTooltip schoolClass={item} tooltip={'Demoklass med demoelever - prova Doklets funktioner.'} />
          }
        </Fragment>
      ))}
      {items?.map((item, index) => (
        <Fragment key={item.id}>
          { resourceType === SCHOOL_RESOURCE_TYPES.GROUP &&
            <SchoolGroupCard key={index} schoolGroup={item} />
          }
          { resourceType === SCHOOL_RESOURCE_TYPES.CLASS &&
            <SchoolClassCardWithTooltip key={index} schoolClass={item} tooltip={currentUser?.hasPaidLicense ? undefined : 'Det här är din riktiga klass. Låt dina elever skriva in sig.'} />
          }
        </Fragment>
      ))}
    </GridColumns>
  )
}

SchoolResourceList.propTypes = {
  items: PropTypes.array,
  demoItems: PropTypes.array,
  gridCols: PropTypes.number,
  resourceType: PropTypes.string.isRequired
}

export default SchoolResourceList
